$.extend(Pikaday.defaults, {
  firstDay: 1,
  i18n: {
    previousMonth: "<i class='fa fa-angle-left'></i>",
    nextMonth: "<i class='fa fa-angle-right'></i>",
    months: moment.months(true),
    weekdays: moment.weekdays().join("_").toLowerCase().split("_"),
    weekdaysShort: moment.weekdaysShort().join("_").toLowerCase().split("_")
  }
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/config/pikaday.js